export default __webpack_public_path__ + "static/media/NeonFood_donut_v002_4.8b31d8f7.gif";